var path = '/signup-basic/account/_sidebar.html';
var html = "<h2 class=\"text-center md-subhead\">Did you know?</h2> <ol> <li>Design the solution you always want for your customer</li> <li>Test, publish and promote your new experience on social media</li> <li>Track and measure your campaign’s performance</li> <li>Over 50,000 customers rate better engagement with Augmented reality</li> </ol> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./signup-basic/account/_sidebar.html
// module id = 285
// module chunks = 0